var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "fillSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("Fill")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.fillSection ? "chevron-up" : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c("b-collapse", { attrs: { visible: _vm.isOpen.fillSection } }, [
                _c("div", [
                  _c(
                    "div",
                    [
                      _c(
                        "b-form-group",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isNotLine,
                              expression: "isNotLine",
                            },
                          ],
                          attrs: { label: "Fill Type", "label-cols": "4" },
                        },
                        [
                          _c("b-form-radio-group", {
                            staticClass: "fill-type-selector",
                            attrs: { options: _vm.fillTypeOptions },
                            on: { change: _vm.onFillTypeChange },
                            model: {
                              value: _vm.fillType,
                              callback: function ($$v) {
                                _vm.fillType = $$v
                              },
                              expression: "fillType",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-baseline position-relative",
                        },
                        [
                          _c(
                            "b-form-group",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.isNotLine && _vm.fillType === "solid",
                                  expression:
                                    "isNotLine && fillType === 'solid'",
                                },
                              ],
                              staticClass: "flex-grow-1",
                              attrs: {
                                label: "Fill Color",
                                "label-cols": "4",
                                "label-class": "text-nowrap pr-3",
                              },
                            },
                            [
                              _c("ColorPicker", {
                                attrs: {
                                  value:
                                    typeof _vm.target.fill === "string"
                                      ? _vm.target.fill
                                      : "#000000",
                                  themes: _vm.themes,
                                  copy: "",
                                },
                                on: {
                                  input: (value) => {
                                    _vm.onChange("bgColor", value)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isShodShowBrandColor
                            ? _c(
                                "b-button",
                                {
                                  staticClass:
                                    "p-0 no-focus-outline add-to-color-table",
                                  attrs: { variant: "link" },
                                  on: { click: _vm.showBrandColors },
                                },
                                [
                                  _vm._v(
                                    "\n                Add to Color Table\n              "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.fillType === "gradient"
                        ? [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Gradient Type",
                                  "label-cols": "4",
                                },
                              },
                              [
                                _c("b-form-radio-group", {
                                  attrs: { options: _vm.gradientTypeOptions },
                                  on: { change: _vm.updateGradient },
                                  model: {
                                    value: _vm.gradientType,
                                    callback: function ($$v) {
                                      _vm.gradientType = $$v
                                    },
                                    expression: "gradientType",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.gradientType === "linear"
                              ? _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Direction",
                                      "label-cols": "4",
                                    },
                                  },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        options: _vm.gradientDirectionOptions,
                                      },
                                      on: { change: _vm.updateGradient },
                                      model: {
                                        value: _vm.gradientDirection,
                                        callback: function ($$v) {
                                          _vm.gradientDirection = $$v
                                        },
                                        expression: "gradientDirection",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Gradient Colors",
                                  "label-cols": "4",
                                },
                              },
                              [
                                _vm._l(_vm.colorStops, function (stop, index) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "d-flex mb-2" },
                                    [
                                      _c("ColorPicker", {
                                        attrs: {
                                          value: stop.color,
                                          themes: _vm.themes,
                                          copy: "",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.updateColorStop(
                                              index,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("b-input", {
                                        staticClass: "ml-2",
                                        staticStyle: { width: "80px" },
                                        attrs: {
                                          type: "number",
                                          min: "0",
                                          max: "100",
                                          step: "1",
                                        },
                                        on: { input: _vm.updateGradient },
                                        model: {
                                          value: stop.offset,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              stop,
                                              "offset",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "stop.offset",
                                        },
                                      }),
                                      _vm._v(" "),
                                      index > 1
                                        ? _c(
                                            "b-button",
                                            {
                                              staticClass: "ml-2",
                                              attrs: {
                                                variant: "danger",
                                                size: "sm",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeColorStop(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("b-icon", {
                                                attrs: { icon: "trash" },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }),
                                _vm._v(" "),
                                _vm.colorStops.length < 5
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "primary",
                                          size: "sm",
                                        },
                                        on: { click: _vm.addColorStop },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Add Color Stop\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "borderSettingsSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("Border Settings")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.borderSettingsSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.borderSettingsSection } },
                [
                  _c("div", [
                    _c(
                      "div",
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Border", "label-cols": "4" } },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex" },
                              [
                                _c("ColorPicker", {
                                  attrs: {
                                    value: _vm.target.stroke,
                                    themes: _vm.themes,
                                    copy: "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onChange("strokeColor", $event)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true },
                                      },
                                    ],
                                    attrs: {
                                      variant: "primary",
                                      size: "sm",
                                      title: "Use background color",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onChange(
                                          "strokeColor",
                                          _vm.target.fill
                                        )
                                      },
                                    },
                                  },
                                  [_c("b-icon", { attrs: { icon: "back" } })],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: _vm.borderWidthName(),
                              disabled: _vm.target.locked,
                            },
                          },
                          [
                            _c(
                              "b-input-group",
                              {
                                scopedSlots: _vm._u([
                                  {
                                    key: "append",
                                    fn: function () {
                                      return [
                                        _c("b-input", {
                                          attrs: {
                                            value: _vm.target.strokeWidth,
                                            min: 0,
                                            max: _vm.maxStrokeWidth,
                                            type: "number",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onChange(
                                                "thickness",
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              },
                              [
                                _c("b-input", {
                                  attrs: {
                                    value: _vm.target.strokeWidth,
                                    min: 0,
                                    max: _vm.maxStrokeWidth,
                                    type: "range",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onChange("thickness", $event)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.isNotLine && _vm.isNotFieldTypeCutLine
                          ? _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Line length",
                                  disabled: _vm.target.locked,
                                },
                              },
                              [
                                _c(
                                  "b-input-group",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "append",
                                          fn: function () {
                                            return [
                                              _c("b-input", {
                                                attrs: {
                                                  value: parseInt(
                                                    _vm.target.coords[2]
                                                  ),
                                                  min: 1,
                                                  max: 2000,
                                                  type: "number",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.onChange(
                                                      "coords",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      2493972812
                                    ),
                                  },
                                  [
                                    _c("b-input", {
                                      attrs: {
                                        value: parseInt(_vm.target.coords[2]),
                                        min: 1,
                                        max: 2000,
                                        type: "range",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.onChange("coords", $event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.target.fieldType !== _vm.FIELD_TYPE_SAFE_ZONE &&
                        _vm.isNotLine
                          ? _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Rounding",
                                  disabled: _vm.target.locked,
                                },
                              },
                              [
                                _c(
                                  "b-input-group",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "append",
                                          fn: function () {
                                            return [
                                              _c("b-input", {
                                                attrs: {
                                                  min: 0,
                                                  max: _vm.maxRounding,
                                                  type: "number",
                                                },
                                                on: {
                                                  input: _vm.onRadiusInput,
                                                },
                                                model: {
                                                  value: _vm.localRadius,
                                                  callback: function ($$v) {
                                                    _vm.localRadius =
                                                      _vm._n($$v)
                                                  },
                                                  expression: "localRadius",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3444669483
                                    ),
                                  },
                                  [
                                    _c("b-input", {
                                      attrs: {
                                        min: 0,
                                        max: _vm.maxRounding,
                                        type: "range",
                                      },
                                      on: { input: _vm.onRadiusInput },
                                      model: {
                                        value: _vm.localRadius,
                                        callback: function ($$v) {
                                          _vm.localRadius = _vm._n($$v)
                                        },
                                        expression: "localRadius",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "opacitySettingsSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("Opacity Settings")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.opacitySettingsSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.opacitySettingsSection } },
                [
                  _c("div", [
                    _c(
                      "div",
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Opacity" } },
                          [
                            _c(
                              "b-input-group",
                              {
                                scopedSlots: _vm._u([
                                  {
                                    key: "append",
                                    fn: function () {
                                      return [
                                        _c("b-input", {
                                          attrs: {
                                            value: _vm.target.opacity,
                                            min: 0,
                                            max: _vm.maxOpacity,
                                            step: "0.01",
                                            type: "number",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onChange(
                                                "opacity",
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              },
                              [
                                _c("b-input", {
                                  attrs: {
                                    value: _vm.target.opacity,
                                    min: 0,
                                    max: _vm.maxOpacity,
                                    step: "0.01",
                                    type: "range",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onChange("opacity", $event)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isNotLine,
                                expression: "isNotLine",
                              },
                            ],
                            attrs: { label: "Fill opacity" },
                          },
                          [
                            _c(
                              "b-input-group",
                              {
                                scopedSlots: _vm._u([
                                  {
                                    key: "append",
                                    fn: function () {
                                      return [
                                        _c("b-input", {
                                          attrs: {
                                            min: 0,
                                            max: 1,
                                            step: "0.01",
                                            type: "number",
                                          },
                                          on: {
                                            input: _vm.onChangeFillOpacity,
                                          },
                                          model: {
                                            value: _vm.fillOpacity,
                                            callback: function ($$v) {
                                              _vm.fillOpacity = $$v
                                            },
                                            expression: "fillOpacity",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              },
                              [
                                _c("b-input", {
                                  attrs: {
                                    min: 0,
                                    max: 1,
                                    step: "0.01",
                                    type: "range",
                                  },
                                  on: { input: _vm.onChangeFillOpacity },
                                  model: {
                                    value: _vm.fillOpacity,
                                    callback: function ($$v) {
                                      _vm.fillOpacity = $$v
                                    },
                                    expression: "fillOpacity",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          { attrs: { label: "Border opacity" } },
                          [
                            _c(
                              "b-input-group",
                              {
                                scopedSlots: _vm._u([
                                  {
                                    key: "append",
                                    fn: function () {
                                      return [
                                        _c("b-input", {
                                          attrs: {
                                            min: 0,
                                            max: _vm.maxOpacity,
                                            step: "0.01",
                                            type: "number",
                                          },
                                          on: {
                                            input: _vm.onChangeStrokeOpacity,
                                          },
                                          model: {
                                            value: _vm.strokeOpacity,
                                            callback: function ($$v) {
                                              _vm.strokeOpacity = $$v
                                            },
                                            expression: "strokeOpacity",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              },
                              [
                                _c("b-input", {
                                  attrs: {
                                    min: 0,
                                    max: _vm.maxOpacity,
                                    step: "0.01",
                                    type: "range",
                                  },
                                  on: { input: _vm.onChangeStrokeOpacity },
                                  model: {
                                    value: _vm.strokeOpacity,
                                    callback: function ($$v) {
                                      _vm.strokeOpacity = $$v
                                    },
                                    expression: "strokeOpacity",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isRelatedFieldChangeAvailable
                          ? _c(
                              "b-form-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      { attrs: { label: "Related field" } },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            value:
                                              _vm.target.relatedField?.field,
                                            options: _vm.relatedTemplateFields,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onChange(
                                                "changeRelatedField2",
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      { attrs: { label: "Margin" } },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            value:
                                              _vm.target.relatedField?.margin,
                                            type: "number",
                                            min: "0",
                                            step: "1",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onChange(
                                                "changeMargin",
                                                $event
                                              )
                                            },
                                            dblclick: _vm.selectValueOnDblclick,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.targetTypeRectangleOrAdditionalFieldRectangleOrSaveZone || _vm.isLine
        ? [
            _vm.isLine ? _c("label", [_vm._v("Position")]) : _vm._e(),
            _vm._v(" "),
            _c("PositionAndSize", {
              attrs: {
                w: _vm.target.width * _vm.target.scaleX,
                h: _vm.target.height * _vm.target.scaleY,
                x: _vm.target.left,
                y: _vm.target.top,
                "show-keep-aspect-ratio": false,
                "show-size": !_vm.isLine,
                "is-open": _vm.isOpen,
              },
              on: {
                toggleSection: _vm.toggleSectionHandler,
                input: _vm.onChange,
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "actionSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("Actions")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.actionSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.actionSection } },
                [
                  _c(
                    "div",
                    [
                      _vm.isAlignAvailable
                        ? _c(
                            "div",
                            {
                              staticClass: "shape-editor-actions d-flex my-2",
                              staticStyle: { "grid-gap": "1rem" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  attrs: { title: "Set to template width" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChange(
                                        "setTemplateSizeByWidth"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: { src: "/img/icons/expand.svg" },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  attrs: { title: "Center to template width" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChange(
                                        "centerToTemplateWidth"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/img/icons/align-center.png",
                                      alt: "align-center-icon",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  attrs: { title: "Left align to template" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChange("leftAlignToTemplate")
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/img/icons/align-left.png",
                                      alt: "align-left-icon",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  attrs: { title: "Right align to template" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChange(
                                        "rightAlignToTemplate"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/img/icons/align-right.png",
                                      alt: "align-right-icon",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "position-fixed apply-to-all-shapes-section",
                        },
                        [
                          _vm.isApplyToAllAvailable
                            ? _c("ApplyToAllShapesDropdown", {
                                attrs: { target: _vm.target },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isOrientationAvailable
                        ? _c(
                            "b-form-group",
                            { attrs: { label: "Orientation" } },
                            [
                              _c("b-form-radio-group", {
                                attrs: {
                                  options: _vm.orientationOptions,
                                  name: "orientation",
                                },
                                on: { change: _vm.onChangeOrientation },
                                model: {
                                  value: _vm.orientation,
                                  callback: function ($$v) {
                                    _vm.orientation = $$v
                                  },
                                  expression: "orientation",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isOrientationAvailable
                        ? _c(
                            "b-form-group",
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    label: "Include line width",
                                    name: "includeLineWidth",
                                  },
                                  on: { change: _vm.onChangeIncludeLineWidth },
                                  model: {
                                    value: _vm.includeLineWidth,
                                    callback: function ($$v) {
                                      _vm.includeLineWidth = $$v
                                    },
                                    expression: "includeLineWidth",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Include line width\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isNonDeletable
        ? _c(
            "b-button",
            {
              attrs: { variant: "danger" },
              on: {
                click: function ($event) {
                  return _vm.onChange("delete")
                },
              },
            },
            [
              _c("b-icon", { attrs: { icon: "trash" } }),
              _vm._v("\n    Delete\n  "),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("LockToggle"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }